module.exports = __webpack_public_path__ + "813119124ea0b0f0cf19b1b91cd30663.svg";